// 完了ページに出す名前の受け渡し。URL に載せると計測に漏れるので sessionStorage を通す。
// 決済と体験予約でキーを分け、片方の名前がもう片方の完了ページに出ないようにする。
export type DoneNameKind = "pay" | "trial";

const keyOf = (kind: DoneNameKind) => `yumesaku:done-name:${kind}`;

export function saveDoneName(kind: DoneNameKind, name: string): void {
  try {
    window.sessionStorage.setItem(keyOf(kind), name);
  } catch {
    // 保存できなくても完了ページは名前なしで出せる
  }
}

export function readDoneName(kind: DoneNameKind): string | null {
  try {
    const value = window.sessionStorage.getItem(keyOf(kind));
    return value && value.length <= 100 ? value : null;
  } catch {
    return null;
  }
}
